export function replace(input: string, pattern: RegExp, replacement: string): string {
    if (typeof input !== 'string' || pattern === undefined || replacement === undefined) {
        return input;
    }

    return input.replace(pattern, replacement);
}
